<template>
  <div>
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ !title ? 'Dropdown Settings' : title }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <repeater
                    :inputs-to-add="bulkEdit"
                    @changeRepeater="changeRepeater"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="bulkEditField"
                    label="Bulk Edit"
                    solo
                    required
                    @change="changeBulkEdit"
                  />
                  <small>Value in each line</small>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="btn btn-primary"
              rounded
              @click="dialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row style="justify-content: center">
        <v-btn
          class="mx-2"
          fab
          small
          light
          color="btn btn-primary"
          @click.stop="dialog = true"
        >
          <i class="fa fa-cog"/>
        </v-btn>
      </v-row>
    </v-row>
  </div>
</template>

<script>
import Repeater from './Repeater'

export default {
  name: 'Dropdown',
  components: {
    Repeater,
  },
  props: ['item', 'title'],
  data() {
    return {
      bulkEdit: [],
      bulkEditField: '',
      dialog: false,
    }
  },
  watch: {
    bulkEdit(val) {
      this.$set(this.item, 'options', val)
    }
  },
  mounted() {
    if (typeof this.item.options === "object")
      this.changeRepeater(this.item.options)
  },
  methods: {
    changeBulkEdit() {
      try {

        let bulk = this.bulkEditField.split("\n")
        this.bulkEdit = []
        bulk.forEach((value, index, array) => {
          this.bulkEdit.push({value: value})
        })

      } catch (e) {
        console.warn(e)
      }
    },
    changeRepeater(val) {
      this.bulkEdit = val
      this.setBulkEditText()
    },
    setBulkEditText() {
      try {

        if (typeof this.bulkEdit !== "object") {
          throw 'Not object';
        }

        let r = '';

        for (var key in this.bulkEdit) {
          r += this.bulkEdit[key].value + "\r\n"
        }

        this.bulkEditField = r

        return r
      } catch (e) {
        console.warn(e)
        return ''
      }
    }
  },
}
</script>
